import { faker } from '@faker-js/faker'
import { generateUUID } from '@fixtures/generate'
import { MockFactory } from '@tino-frontend/mocks'
import { GetMerchantInstallmentsResponse, MerchantInstallment } from '@types'

export function generateMerchantInstallment(
  params?: Partial<MerchantInstallment>
): MerchantInstallment {
  return {
    id: params?.id ?? generateUUID(),
    number: params?.number ?? faker.number.int({ min: 1, max: 3 }),
    total: 3,
    amount_cents:
      params?.amount_cents ?? faker.number.int({ min: 10000, max: 1000000 }),
    estimated_due_date:
      params?.estimated_due_date ?? faker.date.recent().toISOString(),
    created_at: params?.estimated_due_date ?? faker.date.recent().toISOString(),
    external_id: params?.external_id ?? generateUUID(),
    file_url: params?.file_url ?? faker.internet.url(),
  }
}

export const getMerchantInstallmentsMock =
  new MockFactory<GetMerchantInstallmentsResponse>({
    total_installments: 6,
    next_settlement_date: faker.date.recent().toISOString(),
    next_week_installments: [
      generateMerchantInstallment({ estimated_due_date: '2025-05-20' }),
      generateMerchantInstallment({ estimated_due_date: '2025-05-20' }),
      generateMerchantInstallment({ estimated_due_date: '2025-05-20' }),
    ],
    future_installments: [
      generateMerchantInstallment({ estimated_due_date: '2025-09-21' }),
      generateMerchantInstallment({ estimated_due_date: '2025-09-25' }),
      generateMerchantInstallment({ estimated_due_date: '2025-09-28' }),
    ],
    this_week_installments: [
      generateMerchantInstallment({
        estimated_due_date: new Date().toISOString(),
      }),
      generateMerchantInstallment({
        estimated_due_date: new Date().toISOString(),
      }),
      generateMerchantInstallment({
        estimated_due_date: new Date().toISOString(),
      }),
    ],
  })
